
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class CoursesGrid extends Serenity.EntityGrid<CoursesRow, any> {
        protected getColumnsKey() { return CoursesColumns.columnsKey; }
        protected getDialogType() { return CoursesDialog; }
        protected getIdProperty() { return CoursesRow.idProperty; }
        protected getInsertPermission() { return CoursesRow.insertPermission; }
        protected getLocalTextPrefix() { return CoursesRow.localTextPrefix; }
        protected getService() { return CoursesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}